import axios from 'axios';
import { SET_TOAST } from './types';
import CryptoJS from 'crypto-js';

export const API_URL = process.env.REACT_APP_API_URL;

const MY_FIRST_DAY = process.env.REACT_APP_MY_FIRST_DAY;

export function errorHandler(dispatch, error, type) {
  console.log('Error type: ', type);

  if (type) {
    dispatch({
      type,
      payload: error.response,
    });
  }
  dispatch({
    type: SET_TOAST,
    payload: {
      type: 'error',
      message: error?.response?.data?.error || 'toaster.errors.500',
    },
  });
}

const prepareDate = () => {
  const now = new Date();

  // Extraire les composants de la date
  const year = now.getFullYear();
  const month = now.getMonth(); // Rappel : les mois sont 0-indexés en JavaScript
  const day = now.getDate();
  const hours = now.getHours();

  // Arrondir les minutes à la dizaine inférieure
  const minutes = now.getMinutes();
  const roundedMinutes = Math.floor(minutes / 10) * 10;

  // Créer une nouvelle date avec les minutes arrondies
  return new Date(year, month, day, hours, roundedMinutes).toISOString();// Génération de l'horodatage en UTC
}

const prepareHeaders = (url, method, body = null) => {
  const timestamp = prepareDate(); 
  const bodyString = body ? JSON.stringify(body) : "";
  const message = `${method}:${url}:${timestamp}:${bodyString}`;
  const firstday = CryptoJS.HmacSHA256(message, MY_FIRST_DAY).toString();
  const config = {};
  config.headers = { 'X-Firstday': firstday};
  return config;
}

export async function postData(errorType, url, dispatch, data, isAuthReq = false) {
  const requestUrl = API_URL + url;
  const config = prepareHeaders(requestUrl, 'POST', data);
  let res = null;
  let error = null;
  try {
    // if (isAuthReq) {
    //   const token = localStorage.getItem('token');
    //   config.headers = { Authorization: `${token}` };
    // }
    res = await axios.post(requestUrl, data, config);
  } catch (err) {
    error = err;
    errorHandler(dispatch, err, errorType);
  }
  return res?.status === 200 || res?.status === 201 ? res : error;
}

export async function postDataFormData(errorType, isAuthReq, url, dispatch, data) {
  const requestUrl = API_URL + url;
  const config = prepareHeaders(requestUrl, 'POST', data);
  config.timeout = 1000 * 60;
  config.headers['Content-Type'] = 'multipart/form-data';

  let res = null;
  let error = null;

  try {
    // if (isAuthReq) {
    //   const token = localStorage.getItem('token');
    //   config.headers = { Authorization: `${token}` };
    // }
    res = await axios.post(requestUrl, data, config);
  } catch (err) {
    error = err;
    errorHandler(dispatch, err, errorType);
  }
  return res?.status === 200 || res?.status === 201 ? res : error;
}

export async function putDataFormData(errorType, isAuthReq, url, dispatch, data) {
  const requestUrl = API_URL + url;
  const config = prepareHeaders(requestUrl, 'PUT', data);
  config.timeout = 1000 * 60;
  config.headers['Content-Type'] = 'multipart/form-data';

  let res = null;
  let error = null;

  try {
    // if (isAuthReq) {
    //   const token = localStorage.getItem('token');
    //   config.headers = { Authorization: `${token}` };
    // }
    res = await axios.put(requestUrl, data, config);
  } catch (err) {
    error = err;
    errorHandler(dispatch, err, errorType);
  }
  return res?.status === 200 || res?.status === 201 ? res : error;
}

export async function getData(errorType, url, dispatch, isAuthReq) {
  const requestUrl = API_URL + url;
  const config = prepareHeaders(requestUrl, 'GET');
  let res = null;
  let error = null;
  // if (isAuthReq) {
  //   const token = localStorage.getItem('token');
  //   config.headers = { Authorization: `${token}` };
  // }
  try {
    res = await axios.get(requestUrl, config);
  } catch (err) {
    error = err;
    errorHandler(dispatch, err, errorType);
  }
  return res?.status === 200 || res?.status === 201 ? res : error;
}

export async function putData(errorType, url, dispatch, data, isAuthReq = true) {
  const requestUrl = API_URL + url;
  const config = prepareHeaders(requestUrl, 'PUT', data);
  let res = null;
  let error = null;
  try {
    // if (isAuthReq) {
    //   const token = localStorage.getItem('token');
    //   config.headers = { Authorization: `${token}` };
    // }
    res = await axios.put(requestUrl, data, config);
  } catch (err) {
    error = err;
    errorHandler(dispatch, error, errorType);
  }
  return res.status === 200 ? res : error;
}

export function deleteData(errorType, url, dispatch, isAuthReq) {
  return new Promise((resolve, reject) => {
    const requestUrl = API_URL + url;

    const config = prepareHeaders(requestUrl, 'DELETE');

    // if (isAuthReq) {
    //   const token = localStorage.getItem('token');
    //   config.headers = {
    //     Authorization: `${token}`,
    //   };
    // }

    axios.delete(requestUrl, config)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject();
        errorHandler(dispatch, error, errorType);
      });
  });
}
